import type {FilterFn} from "@tanstack/react-table";

/**
 * exactMatchArrayFilterFn — filters rows where the column value exactly matches
 * any of the values in the provided array.
 */
export const exactMatchArrayFilterFn: FilterFn<unknown> = (
  row,
  columnId,
  filterValue: string[],
) => {
  if (!filterValue || filterValue.length === 0) return true;
  const value = row.getValue(columnId) as string;

  return filterValue.includes(value);
};

/**
 * dateRangeFilterFn — filters rows where the column value (as an ISO date string)
 * falls within the inclusive start and end dates.
 */
export const dateRangeFilterFn: FilterFn<unknown> = (
  row,
  columnId,
  filterValue: {start: string; end: string},
) => {
  if (!filterValue?.start || !filterValue?.end) return true;
  const cellValue = row.getValue(columnId) as string | undefined;

  if (!cellValue) return false;
  const rowDate = new Date(cellValue).getTime();
  const startDate = new Date(filterValue.start).getTime();
  const endDate = new Date(filterValue.end + "T23:59:59.999Z").getTime();

  return rowDate >= startDate && rowDate <= endDate;
};
